import React,{useState,useRef,useEffect} from 'react'
import axios from 'axios'
import useOnclickOutside from "react-cool-onclickoutside"
import { Button, Message } from 'semantic-ui-react'

import Spinner from '../services/spinner'
import AlertMessage from '../services/alert'
import { WindowReload, WindowURL, WindowLocation, RouteURL, ActiveMenu, ProductionMode } from '../services/redirect'

export default function SidebarMenu(props){

  const handleClickAway = useOnclickOutside(() => CallbackModal({close:true}));
  function CallbackModal(data){
    return false;
    props.callback(data);
  }

  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);


  /*------------------------------------------------------
    NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }


  const [active, setactive] = useState('');
  function Logout(){
    setspinner(true);
    let formData = new FormData();
    formData.append('type','logout');
    axios.post('/auth/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Successfully logout'}});
      setnotify(true);
      setTimeout(function() {
        WindowReload();
        setnotify(false);
      },2000);
      return false;


    })
    .catch(function (error){
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });

  }


  /*------------------------------------------------------
         AUTH PERMISSION FOR DEVS PAGES
  -------------------------------------------------------*/
  const [pageId, setPageId] = useState('pjskth68r3bcq297z');
  const [auth, setAuth] = useState(false);
  function AuthPermission(){
    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;
        if(obj.view==1){
          setAuth(true);
        }
    })
    .catch(function (error){
    });
 }

  useEffect(()=>{
      AuthPermission();
  },[]);


   return (
    <React.Fragment>

        <div className="sidebarpanel-wrapper">
             <div className="sidebarpanel-container animate__animated animate__slideInLeft animate__faster" ref={handleClickAway}>

                 {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}

                 <div className="sidebarpanel-header">
                   <div><img src={props.data.image}/></div>
                   <div>
                     <h1>{props.data.fullname}</h1>
                     <p>{props.data.role_name}</p>
                     <p><i className="circle icon"></i><span>Online</span></p>
                   </div>
                 </div>

                 <div className="sidebarpanel-body">
                    <div className="sidebarpanel-content">

                        <div className="sidebar-menu">
                          <ul>
                              <li className={ActiveMenu('dashboard')?'active':''}><a href={WindowURL('/dashboard')}><i className="uil-home-alt"></i><span>Dashboard</span></a></li>
                              <li className={ActiveMenu('orders')?'active':''}><a href={WindowURL('/orders/list')}><i className="uil-layer-group"></i><span>Orders</span></a></li>

                              <li className={ActiveMenu('customers')?'sidebar-dropdown active':'sidebar-dropdown'}>
                                  <a href="#"><i className="uil-users-alt"></i><span>Customers</span></a>
                                  <div className={ActiveMenu('customers')?'sidebar-submenu active_dropdown':'sidebar-submenu'}>
                                    <ul>
                                      <li><a href={WindowURL('/customers/new')}>New Customer</a></li>
                                      <li><a href={WindowURL('/customers/list')}>List Customer</a></li>
                                      <li><a href={WindowURL('/customers/invite')}>Invite Customer</a></li>
                                    </ul>
                                  </div>
                              </li>

                              <li className={ActiveMenu('products')?'sidebar-dropdown active':'sidebar-dropdown'}>
                                  <a href="#"><i className="uil-box"></i><span>Products</span></a>
                                  <div className={ActiveMenu('products')?'sidebar-submenu active_dropdown':'sidebar-submenu'}>
                                    <ul>
                                      <li><a href={WindowURL('/products/new')}>Create Product</a></li>
                                      <li><a href={WindowURL('/products/list')}>List Product</a></li>

                                    </ul>
                                  </div>
                              </li>

                              {/*<li className={ActiveMenu('processing-notes')?'sidebar-dropdown active':'sidebar-dropdown'}>
                                  <a href="#"><i className="uil-notes"></i><span>Processing Notes</span></a>
                                  <div className={ActiveMenu('processing-notes')?'sidebar-submenu active_dropdown':'sidebar-submenu'}>
                                    <ul>
                                      <li><a href={WindowURL('/processing-notes/create')}>Create Note</a></li>
                                      <li><a href={WindowURL('/processing-notes/list')}>List Notes</a></li>
                                      {/*<li><a href={WindowURL('/processing-notes/deleted_list')}>Deleted Notes</a></li>
                                    </ul>
                                  </div>
                              </li>*/}
                            

                              <li className={ActiveMenu('banners')?'active':''}><a href={WindowURL('/banners/list')}><i className="uil-image"></i><span>Banners</span></a></li>

                              <li className={ActiveMenu('reports')?'sidebar-dropdown active':'sidebar-dropdown'}>
                                  <a href="#"><i className="uil-chart-line"></i><span>Reports</span></a>
                                  <div className={ActiveMenu('reports')?'sidebar-submenu active_dropdown':'sidebar-submenu'}>
                                    <ul>
                                      <li><a href={WindowURL('/reports/processed-orders/weekly')}>Processed Orders Weekly</a></li>
                                      <li><a href={WindowURL('/reports/processed-orders/monthly')}>Processed Orders Monthly</a></li>
                                      <li><a href={WindowURL('/reports/processed-orders/custom-date')}>Processed Orders Custom Date</a></li>
                                      <li><a href={WindowURL('/reports/processed-orders/status')}>Processed Orders Status</a></li>
                                      <li><a href={WindowURL('/reports/processed-orders/total-orders-report')}>Total Orders Report</a></li>
                                      <li><a href={WindowURL('/reports/export-orders')}>Export Orders</a></li>
                                      <li><a href={WindowURL('/reports/processed-orders/email-logs')}>Mail Reports Logs</a></li>
                                    </ul>
                                  </div>
                              </li>

                              <li className={ActiveMenu('compliance')?'sidebar-dropdown active':'sidebar-dropdown'}>
                                  <a href="#"><i className="uil-notes"></i><span>Compliance</span></a>
                                  <div className={ActiveMenu('compliance')?'sidebar-submenu active_dropdown':'sidebar-submenu'}>
                                    <ul>
                                      <li><a href={WindowURL('/compliance/product/list')}>Product Compliance</a></li>
                                      <li><a href={WindowURL('/compliance/country/list')}>Country Compliance</a></li>
                                    </ul>
                                  </div>
                              </li>



                              <li className={ActiveMenu('administration')?'sidebar-dropdown active':'sidebar-dropdown'}>
                                  <a href="#"><i className="uil-cog"></i><span>Administration</span></a>
                                  <div className={ActiveMenu('administration')?'sidebar-submenu active_dropdown':'sidebar-submenu'}>
                                    <ul>
                                      <li><a href={WindowURL('/administration/logs-administrator')}>Logs Administrator</a></li>
                                      <li><a href={WindowURL('/administration/logs-customer')}>Logs Customer</a></li>
                                      <li><a href={WindowURL('/administration/account-lock')}>Account Lock</a></li>
                                      <li><a href={WindowURL('/administration/audit-account')}>Audit Account</a></li>
                                      <li><a href={WindowURL('/administration/deleted-orders')}>Deleted Orders</a></li>
                                      <li><a href={WindowURL('/administration/message')}>Custom Message</a></li>
                                    </ul>
                                  </div>
                              </li>



                              <li className={ActiveMenu('user-management')?'sidebar-dropdown active':'sidebar-dropdown'}>
                                  <a href="#"><i className="uil-users-alt"></i><span>User Management</span></a>
                                  <div className={ActiveMenu('user-management')?'sidebar-submenu active_dropdown':'sidebar-submenu'}>
                                    <ul>
                                      <li><a href={WindowURL('/user-management/list')}>List Users</a></li>
                                      <li><a href={WindowURL('/user-management/role')}>Users Role</a></li>
                                    </ul>
                                  </div>
                              </li>



                              <li id={auth?'':'display_none'} className={ActiveMenu('system-administration')?'sidebar-dropdown active':'sidebar-dropdown'}>
                                  <a href="#"><i className="uil-plug"></i><span>Developer</span></a>
                                  <div className={ActiveMenu('system-administration')?'sidebar-submenu active_dropdown':'sidebar-submenu'}>
                                    <ul>
                                      <li><a href={WindowURL('/system-administration/pages')}>System Pages</a></li>
                                    </ul>
                                  </div>
                              </li>




                          </ul>
                        </div>{/*.sidebar-menu*/}

                    </div>{/*.sidebarpanel-content*/}
                </div>{/*.sidebarpanel-body*/}

                <div className="sidebarpanel-footer">
                    <span><i className="uil-user"></i></span>
                    <span><Button className="RedButton uppercase strong" disabled={spinner} loading={spinner} content='Logout' icon='sign-out' size='tiny' labelPosition='right' onClick={()=>Logout()}/></span>
                </div>

             </div>
           </div>
    </React.Fragment>
  )
}
